import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { ActivityType, ActivityTypeFilter, EventOccasion, EventType, EventVertical } from './meta.types';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class MetaService {
	private eventOccasionsUrl = 'api/eventOccasions';
	private eventVerticalsUrl = 'api/eventVerticals';
	private eventTypesUrl = 'api/eventTypes';
	private activityTypesUrl = 'api/activityTypes';

	constructor(private _http: Http, private http: HttpClient) { }

	getEventOccasions(): Promise<EventOccasion[]> {
		return this.http.get<EventOccasion[]>(this.eventOccasionsUrl).toPromise();
	}

	getEventVerticals(): Promise<EventVertical[]> {
		return this.http.get<EventVertical[]>(this.eventVerticalsUrl).toPromise();
	}

	getActivityTypes(filter?: ActivityTypeFilter): Promise<ActivityType[]> {
		return this._http.get(this.activityTypesUrl, { params: filter })
			.toPromise()
			.then(response => response.json() as ActivityType[]);
	}

	getEventTypes(eventVerticalId?: number): Promise<EventType[]> {
		return this._http.get(this.eventTypesUrl, { params: { eventVerticalId: eventVerticalId } })
				.toPromise()
				.then(response => response.json() as EventType[]);

	}
}
